module.exports = __webpack_public_path__ + "c0cbecbe1bee065a4889d0f982533bc5.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/10-Betsolutions-Okey.png
// module id = 1732
// module chunks = 2